const IO_CONFIG = {
  threshold: 0.3,
  triggerOnce: true,
};

export default IO_CONFIG;
